import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Shape = ({
  width = 16,
  height = 29,
  className,
  color,
  decorative = false,
  ariaLabel = "Shape",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 26 44"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        d="m8 20.28 8 8V.667H0V28.28zm6.667 4.773L8 18.387l-6.667 6.666V2h13.334z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
